import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_BLOPED_FECHAS = 'ALL_BLOPED_FECHAS';
export const ACTIVO_BLOPED_FECHAS = 'ACTIVO_BLOPED_FECHAS';
export const LOADING_ALL_BLOPED_FECHAS = 'LOADING_ALL_BLOPED_FECHAS';
export const PARAMS_BLOPED_FECHAS = 'PARAMS_BLOPED_FECHAS';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {},
};

export const blopedFechasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_BLOPED_FECHAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_BLOPED_FECHAS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_BLOPED_FECHAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_BLOPED_FECHAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
